<template>
  <div>
    <form
      @submit.prevent="submitNewPassword"
      class="block sign_in landscape:mx-auto"
    >
      <div
        class="w-full bg-white landscape:p-3 md:rounded-l-0 rounded-l-lg rounded-r-lg flex items-center justify-center text-gray-950 text-center relative"
      >
        <div class="w-full max-w-md">
          <div class="mb-5">
            <div class="mb-5 flex items-center justify-center">
              <a href="ireserve.shop" title="iReserve Shop">
                <img src="/logo2.png" width="95px" height="15px" />
              </a>
            </div>
            <div
              class="block text-sm sm:text-base text-center px-2 mb-2 font-normal text-gray-600"
            >
              We're sorry you misplaced your password. Please enter a new one,
              something you can easily remember, but difficult for others to
              guess. Use a mix of uppercase and lowercase letters.
            </div>
          </div>
          <p :class="messageClass" class="text-xs py-2 px-2 text-left relative">
            {{ message }}
          </p>
          <div class="mb-[40px]">
            <div class="relative mb-2">
              <input
                :type="showPassword ? 'text' : 'password'"
                id="password"
                name="password"
                title="Enter your password"
                v-model="password"
                :disabled="loading"
                @input="passwordValid"
                required
                class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-600 peer"
                placeholder=""
              />
              <label
                for="password"
                class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >Password</label
              >

              <div
                class="absolute top-1/2 right-2 -translate-y-1/2 flex items-center gap-1"
              >
                <button
                  type="button"
                  @click="showPassword = !showPassword"
                  class="text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <i
                    :class="
                      showPassword
                        ? 'fa-solid fa-eye-slash text-sm'
                        : 'fa-solid fa-eye text-sm'
                    "
                  ></i>
                </button>
                <i class="fa-solid fa-lock text-gray-400"></i>
              </div>
            </div>
            <div
              v-if="passwordError"
              v-bind:class="passwordError ? 'text-red-500' : 'text-linkbutton'"
              class="text-xs py-2 px-2 text-left mb-2 relative"
            >
              Password must be at least 8 characters long and contain at least
              one uppercase letter and one lowercase letter.
            </div>
            <div class="relative mb-2">
              <input
                type="password"
                id="confirmpassword"
                name="confirmpassword"
                title="Re-enter your password"
                v-model="confirmpassword"
                @input="passwordsMatch"
                :disabled="loading"
                required
                class="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-950 bg-transparent border border-t-0 border-r-0 border-l-0 border-gray-400 appearance-none focus:outline-none focus:ring-0 focus:border-gray-600 peer"
                placeholder=""
              />
              <label
                for="confirmpassword"
                class="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1"
                >Confirm password</label
              >
              <span
                class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-400"
              >
                <!-- Lock icon as inline SVG -->
                <i class="fa-solid fa-lock"></i>
              </span>
            </div>
            <div
              v-if="passwordsMatchError"
              class="text-red-500 text-xs py-2 px-2 text-left relative"
            >
              Passwords do not match!
            </div>
          </div>
          <div class="mb-3">
            <button
              class="align-middle select-none font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-sm py-3.5 px-7 rounded-lg text-white shadow-md shadow-button/10 hover:shadow-lg hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none block w-full bg-button p-2"
            >
              <span
                class="flex flex-row justify-center items-center"
                v-if="loading"
              >
                <svg
                  class="h-5 w-5 mr-3 animate-spin text-gray-50"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                >
                  <path
                    d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                    stroke="currentColor"
                    stroke-width="5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                    stroke="currentColor"
                    stroke-width="5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="text-gray-900"
                  ></path>
                </svg>
                Creating new password...
              </span>
              <span v-else>Create new password</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ResetFormComponent",
  data() {
    return {
      password: "",
      confirmpassword: "",
      token: "",
      id: "",
      passwordError: false,
      passwordsMatchError: false,
      message: "",
      messageClass: "",
      loading: false,
      showPassword: false,
    };
  },
  mounted() {
    this.token = this.$route.params.token || "";
    this.id = this.$route.params.id || "";
  },
  methods: {
    ...mapActions(["createNewPassword"]),
    passwordsMatch() {
      this.passwordsMatchError = !(this.password === this.confirmpassword);
    },
    passwordValid() {
      this.passwordError = !(
        this.password.length >= 8 &&
        /[A-Z]/.test(this.password) &&
        /[a-z]/.test(this.password)
      );
    },
    async submitNewPassword() {
      this.loading = true;
      this.message = "";
      const userData = {
        password: this.confirmpassword,
        token: this.token,
        id: this.id,
      };
      try {
        const response = await this.createNewPassword(userData);
        if (response.success) {
          this.message = response.message || "Password reset successfull";
          this.messageClass = "text-green-500";
          const redirectPath = "/login";
          this.$router.push(redirectPath);
        } else {
          this.message = response.message || response.error;
          this.messageClass = "text-red-500";
        }
      } catch (error) {
        this.message =
          error.message || "An error occured during password reset";
        this.messageClass = "text-red-500";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
